import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path: string) => location.pathname.startsWith(path);

  return (
    <nav style={styles.nav}>
      <div style={styles.logo} onClick={() => navigate('/')}>
        🛒 <span style={styles.logoText}>PriceCY</span>
      </div>
      <div style={styles.links}>
        <button
          onClick={() => navigate('/products')}
          style={{ ...styles.link, ...(isActive('/products') ? styles.activeLink : {}) }}>
          Search
        </button>
        {user && (
          <button
            onClick={() => navigate('/lists')}
            style={{ ...styles.link, ...(isActive('/lists') ? styles.activeLink : {}) }}>
            My Lists
          </button>
        )}
        {user?.role === 'admin' && (
          <button
            onClick={() => navigate('/admin')}
            style={{ ...styles.link, ...(isActive('/admin') ? styles.activeLink : {}) }}>
            ⚙️ Admin
          </button>
        )}
      </div>
      <div style={styles.userArea}>
        {user ? (
          <>
            <span style={styles.email}>{user.email}</span>
            <button onClick={logout} style={styles.logoutBtn}>Log out</button>
          </>
        ) : (
          <button onClick={() => navigate('/login')} style={styles.loginBtn}>Log in</button>
        )}
      </div>
    </nav>
  );
};

const styles: Record<string, React.CSSProperties> = {
  nav: {
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    padding: '0 24px', height: 56, background: '#2952CC',
    position: 'sticky', top: 0, zIndex: 100,
    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
    flexWrap: 'wrap' as const,
  },
  logo: { display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' },
  logoText: { color: 'white', fontWeight: 700, fontSize: 18 },
  links: { display: 'flex', gap: 4 },
  link: {
    background: 'none', border: 'none', color: '#B3C6FF',
    fontSize: 14, fontWeight: 500, cursor: 'pointer', padding: '6px 12px', borderRadius: 6,
  },
  activeLink: { color: 'white', background: 'rgba(255,255,255,0.12)' },
  userArea: { display: 'flex', alignItems: 'center', gap: 12 },
  email: { color: '#B3C6FF', fontSize: 11, maxWidth: 120, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' as const },
  logoutBtn: {
    background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.2)',
    color: 'white', padding: '4px 8px', borderRadius: 6, fontSize: 12, cursor: 'pointer',
  },
  loginBtn: {
    background: 'white', border: 'none', color: '#2952CC',
    padding: '6px 14px', borderRadius: 6, fontSize: 13, fontWeight: 600, cursor: 'pointer',
  },
};

export default Navbar;
